import { Button } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import FormCheckbox from '@Components/Form/FormCheckBox';

const FormCheckboxs = () => {
  const formContext = useForm<{ name: string }>({ mode: 'onTouched' });

  return (
    <FormProvider {...formContext}>
      <FormCheckbox
        name="option1"
        label="Default สี่เหลี่ยม"
        rules={{ required: 'This field is required' }}
      />
      <FormCheckbox
        name="option3"
        disabled
        label="Disabled checkbox"
        rules={{ required: 'This field is required' }}
      />
      <FormCheckbox
        defaultChecked={true}
        name="option4"
        label="Default Checked checkbox"
        rules={{ required: 'This field is required' }}
      />
      <Button
        onClick={formContext.handleSubmit((value) => {
          console.log(value);
        })}
      >
        Submit
      </Button>
    </FormProvider>
  );
};

export default FormCheckboxs;
